export default __webpack_public_path__ + "static/media/feg-logo.b38de73c.svg";